import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";
import smsAuthHeader from "./sms-auth-headers";
import qs from "qs";

const API_URL = process.env.BFF_URL + '/merchants'

class CustomerService {

  create(mid, user) {
    return http.post(API_URL + `/${mid}/v1/customers`, user, {headers: authHeader()});
  }

  update(mid, id, user) {
    return http.put(API_URL + `/${mid}/v1/customers/${id}`, user, {headers: authHeader()});
  }

  findById(mid, id) {
    return http.get(API_URL + `/${mid}/v1/customers/${id}`, {headers: authHeader()});
  }

  delete(mid, id) {
    return http.delete(API_URL + `/${mid}/v1/customers/${id}`, {headers: authHeader()});
  }

  find(mid, params) {
    return http.get(`${API_URL}/${mid}/v1/customers`, {
      params: params, paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: 'repeat'})
      }, headers: authHeader()
    });
  }

  fetchEmails(mid, id) {
    return http.get(API_URL + `/${mid}/v1/customers/${id}/emails`, {headers: authHeader()});
  }

  emailStatement(mid, customerId, data, params) {
    return http.post(API_URL + `/${mid}/v1/customers/${customerId}/statement/email`, data, {
      params: params,
      headers: authHeader()
    });
  }

  report(mid) {
    return http.get(API_URL + `/${mid}/v1/customers/report`, {headers: authHeader()})
  }

  findCustomerOwners(mid, customerId, page, size) {
    return http.get(API_URL + `/${mid}/v1/customers/${customerId}/owners?page=${page}&size=${size}`, {headers: authHeader()})
  }

  findCustomers(mid, params) {
    return http.get(API_URL + `/${mid}/v1/customers`, {params: params, headers: authHeader()});
  }

  findOwners(mid, customerId, page, size) {
    return http.get(API_URL + `/${mid}/v1/customers/${customerId}/owners?page=${page}&size=${size}`, {headers: authHeader()})
  }

  findByVendorId(mid, name, email, phone, page, size) {
    return http.get(API_URL + `/${mid}/v1/customers`, {
      params: {
        name: name,
        email: email,
        phone: phone,
        page: page,
        size: size
      },
      headers: authHeader()
    })
  }

  uploadCustomers(mid, file) {
    let formData = new FormData();
    formData.append("file", file)
    formData.append("merchantId", mid)
    return http.post(API_URL + `/${mid}/v1/customers/upload`, formData, {headers: smsAuthHeader()});
  }

  findMerchantGroups(mid, page, size) {
    return http.get(API_URL + `/${mid}/v1/customers/groups?page=${page}&size=${size}`, {headers: authHeader()})
  }

  handleResponse(response) {
    return response
  }
}

export default new CustomerService();



// WEBPACK FOOTER //
// ./src/service/customer.service.js